function randomSwap(list: number[]) : number[]{
    const firstIndex = Math.floor(Math.random() * list.length);
    const secondIndex = Math.floor(Math.random() * (list.length - firstIndex) + firstIndex);
    
    if (firstIndex !== secondIndex) {
        return list.slice(0, firstIndex).concat(list[secondIndex])
               .concat(list.slice(firstIndex+1, secondIndex))
               .concat(list[firstIndex]).concat(list.slice(secondIndex+1));
    }
    return list; 
}

function randomShuffle(list: number[], shuffleCount: number) : number[]{
    if (shuffleCount === 0){
        return list;
    }
    else {
        return randomShuffle(randomSwap(list), shuffleCount - 1);
    }
}

function randomList(length: number) : number[]{
    return Array.from({length}, () => Math.ceil(Math.random() * length));
}

function reverseList(list: number[], countLeft: number, countRight: number) : number[] {
    if (countRight - countLeft <= 0){
        return list;
    }
    else {
        return reverseList(list.slice(0, countLeft).concat(list[countRight])
               .concat(list.slice(countLeft+1, countRight)).concat(list[countLeft])
               .concat(list.slice(countRight+1)), countLeft+1, countRight-1);
    }
}

function nearlySortedRandomList(max:number, min:number, length: number) : number[]{
    const sortedList = Array(length).fill(0);
    sortedList.forEach((item, index) => {
        sortedList[index] = Math.ceil(index * ((max - min)/100)) + min;
    });
    const shuffleCount = Math.ceil(Math.random() * (length/5));
    const nearlySortedList = randomShuffle(sortedList, shuffleCount)
    return nearlySortedList;
}

function reversedNearlySortedRandomList(max:number, min:number, length: number) : number[]{
    return reverseList(nearlySortedRandomList(max, min, length), 0, length-1);
}

export{
    randomList,
    nearlySortedRandomList,
    reversedNearlySortedRandomList
}